export default __webpack_public_path__ + "static/media/phone-home.151e589f.jpg";